var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatapultIconLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.08 10.79L30.2995 3.64072L31.9502 2.58706V0.983154L26.3268 4.59681C24.1102 6.0134 20.6566 8.22608 20.1727 8.53047C18.1044 9.84559 17.2615 11.391 17 12.6436C17.5918 11.9205 18.2937 11.2949 19.08 10.79Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9502 8.96365V7.36755L19.6966 15.3363C18.0849 16.4954 17 18.1227 17 20.1676C17.0015 21.0471 17.2057 21.9146 17.5969 22.7024C17.9881 23.4902 18.5557 24.1772 19.2556 24.71L31.9502 32.9832V26.0329L21.878 19.7149C21.5531 19.4963 21.2871 19.2012 21.1033 18.8554C20.9195 18.5097 20.8237 18.124 20.8244 17.7324C20.8226 17.3454 20.9177 16.9641 21.101 16.6233C21.2844 16.2825 21.5502 15.993 21.8741 15.7812L31.9502 8.96365Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7629 11.9608C17.8663 13.1666 17.1405 14.4817 17 16.0037C17.7342 15.1424 18.5916 14.3941 19.5444 13.7832L31.9502 5.77541V4.1676L19.7629 11.9608Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatapultIconLogo);
export default __webpack_public_path__ + "static/media/catapult-icon-logo.cee843c609b3e1884a56a98c2be4730a.svg";
export { ForwardRef as ReactComponent };